export default __webpack_public_path__ + "static/media/301.a09df8aa.png";